import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import Text from "../../atoms/Text"
import ContentCard from "../../molecules/ContentCard"

export default class MainContents extends Component {
  render() {
    return (
      <Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="こんな仲間を求めます">
            <Text>・笑顔で挨拶ができる人</Text>
            <Text>・要領が悪い人</Text>
            <Text>・人と違っていることを恐れない人</Text>
            <Text>・明るく面白い人</Text>
            <Text>・約束を大切だと思う人</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="選考">
            <Text bold inlineBox>
              2020年度の選考情報は随時お知らせします。
            </Text>
          </ContentCard>
        </Grid>
      </Grid>
    )
  }
}
